// Ported verbatim (behaviour) from eb-ui
// `packages/attendee/trending/src/utils.ts`, swapping `@eventbrite/i18n` gettext
// for the local plain-string gettext (src/i18n/gettext.ts).

import { gettext } from './i18n/gettext';
import { Timeframe, TimeframesMap } from './types';

export const formatSearchUrl = (
    location: string,
    term: string,
    localeSubdirectory: string,
): string => `${localeSubdirectory}/d/${location}/${term}/`;

export const timeframesMap: TimeframesMap = {
    day: gettext('Daily'),
    week: gettext('Weekly'),
    month: gettext('Monthly'),
    year: gettext('Yearly'),
};

export const formatPageTitle = (location: string, timeframe: Timeframe): string => {
    const ordinalTimeframe = timeframesMap[timeframe] || timeframesMap.week;

    return location === 'Online'
        ? gettext('%(ordinalTimeframe)s trending searches for Online Events', {
              ordinalTimeframe,
          })
        : gettext('%(ordinalTimeframe)s trending searches in %(location)s', {
              ordinalTimeframe,
              location,
          });
};

export const formatTrendingSearchPageTitle = (location: string): string => {
    return location === 'Online'
        ? gettext('Trending searches for Online Events')
        : gettext('Trending searches in %(location)s', {
              location,
          });
};
